import React from 'react'

const getMediaIcon = function(attachmentType) {
  let icon
  switch(attachmentType){
  case 'pdf':
    icon = <i className='fa fa-file-pdf-o' aria-hidden='true'></i>
    break
  case 'audio':
    icon = <i className='fa fa-file-audio-o' aria-hidden='true'></i>
    break
  case 'image':
    icon = <i className='fa fa-file-image-o' aria-hidden='true'></i>
    break
  case 'video':
    icon = <i className='fa fa-file-video-o' aria-hidden='true'></i>
    break
  case 'word':
    icon = <i className='fa fa-file-word-o' aria-hidden='true'></i>
    break
  case 'excel':
    icon = <i className='fa fa-file-excel-o' aria-hidden='true'></i>
    break
  case 'powerpoint':
    icon = <i className='fa fa-file-powerpoint-o' aria-hidden='true'></i>
    break
  default:
    icon = <i className='fa fa-file-o' aria-hidden='true'></i>
    break
  }
  return icon
}

export default getMediaIcon
